 /* eslint-disable */
<template>
  <div class="box">
    <div class="shadow"></div>
    <div class="content">
      <p>请输入领取Q币信息</p>
      <input type="number" class="Input mt" placeholder="请输入你的QQ号" maxlength="14" v-model="qq" />
      <input type="text" class="Input mt" placeholder="请输入你的QQ昵称" v-model="nickname" />
      <button class="btn0 mt" @click="handlefillQQ">确定</button>
      <div class="cancel" @click="handleCancle"></div>
    </div>
    <Bingo
      v-if="open"
      :title="title"
      @cancle="(obj)=>{
      if(obj){
        this.$emit('cancle');
      }
      this.open=!this.open;
      }"
    />
  </div>
</template>

<script>
import Bingo from "../common/Bingo";
import { fill_address, my_address } from "../../utils/config";
export default {
  props: {
    drawId: {
      type: Number,
      default: 0,
      required: true
    }
  },
  components: {
    Bingo
  },
  mounted() {
    this.$axios({
      withCredentials: true,
      crossDomain: true,
      method: "get",
      url: my_address,
      params: {
        prizeType: "QB"
      }
    }).then(res => {
      let { data } = res.data;
      let address = data.address.split("/");
      this.qq = address[0]
      this.nickname = address[1]
    });
  },
  data: () => ({
    qq: "",
    nickname: "",
    open: false,
    title: ""
  }),

  methods: {
    handleCancle() {
      this.$emit("cancle");
    },
    handlefillQQ() {
      this.$axios({
        withCredentials: true,
        crossDomain: true,
        method: "get",
        url: fill_address,
        params: {
          drawId: this.drawId,
          address: `${this.qq}/${this.nickname}`
        }
      }).then(res => {
        let { data } = res;
        if (data.code == 0) {
          this.title = data;
          this.open = true;
        } else {
          this.title = data.msg;
          this.open = true;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.box {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
}
.shadow {
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.5;
}
.content {
  position: absolute;
  border-radius: 10px;
  left: 50%;
  top: 29%;
  transform: translateX(-50%);
  width: 660px;
  text-align: center;
  font-size: 24px;
  background: #fff;
  z-index: 99999;
  padding: 35px 35px 0;
  .Input {
    width: 100%;
    height: 70px;
    border: 1px solid #c6c6c6;
    border-radius: 10px;
    font-size: 20px;
    padding-left: 35px;
  }
  .mt {
    margin-top: 40px;
  }
  .mt1 {
    margin-top: 10px;
  }
  .btn0 {
    width: 100%;
    height: 70px;
    background: #d753f0;
    text-align: center;
    line-height: 70px;
    font-size: 24px;
    color: #fff;
    border-radius: 10px;
  }
  .myGoods {
    margin-top: 40px;
    height: 495px;
    overflow-y: scroll;
    li {
      position: relative;
      margin-bottom: 10px;
      height: 92px;
      border-bottom: 2px solid #e1e1e1;
      text-align: left;
      .goods {
        font-size: 20px;
        margin-bottom: 12px;
      }
      .msg {
        font-size: 16px;
        margin-bottom: 14px;
      }
      .time {
        font-size: 12px;
        color: #868686;
      }
      .btnPosition {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 14px;
      }
    }
  }
  .text {
    font-size: 20px;
    padding-left: 35px;
    padding-top: 25px;
    width: 100%;
    border: 2px solid #c6c6c6;
    border-radius: 2px;
    height: 176px;
  }
}
.cancel {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  bottom: -100px;
  height: 48px;
  width: 48px;
  background: url("../assets/guanbi.png") no-repeat;
  background-size: 100% 100%;
}
</style>
